<template>
  <BaseButton
    class="filter-sort-button"
    text="Filter and Sort"
    @click="emit('click', $event)">
    <template #icon>
      <SvgFilters/>
    </template>
  </BaseButton>
</template>
<script setup>
import BaseButton from '@shared/components/ADORN/BaseButton'
import SvgFilters from '@/components/global/svg/SvgFilters.vue'

const emit = defineEmits({
  click: (event) => event instanceof MouseEvent
})
</script>

<style lang="scss" scoped>
.filter-sort-button.base-button {
  background-color: $plum;
  color: $white;
  --icon-size: 18px;
  column-gap: $spacing-xs;
  padding-left: $spacing-md;
  padding-right: $spacing-md;


  &.condensed {
    padding-left: $spacing-sm;
    padding-right: $spacing-sm;
    --icon-size: 16px;
  }
}
</style>
